import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { RootState, RootDispatch } from '.';

export const useAppDispatch = (): RootDispatch => { return useDispatch<RootDispatch>(); };
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
